import {assetIsPresent, isAssetCheckedOut} from '@netx/core-asset-next/utils';
import {
	allows,
	PermissionMatrixName,
} from '@netx/core-permissions/utils/allows';
import {type IAsset} from '../schema';

export const canDownloadAsset = (asset?: IAsset) =>
	asset != null &&
	!isAssetCheckedOut(asset) &&
	assetIsPresent(asset) &&
	allows(asset.permissionMatrix, PermissionMatrixName.DOWNLOAD);

export default canDownloadAsset;
